import Vue from 'vue'


import VConsole from 'vconsole';

// const vConsole = new VConsole();
// 或者使用配置参数来初始化，详情见文档
// const vConsole = new VConsole({ theme: 'dark' });


// 结束调试后，可移除掉
// vConsole.destroy();

document.title = '实时监控'
import App from './App.vue'
import router from './router'

import './assets/main.css'
import { Button ,Picker, Dialog, Toast} from 'vant';
import { showToast } from '../utils/toast';
Vue.prototype.$showToast = showToast;

Vue.use(Button)
Vue.use(Picker)
Vue.use(Dialog)
Vue.use(Toast)

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
